<div class="not-found-container">
    <div class="not-found-content">
        <!-- 404 Graphic -->
        <div class="error-code">
            <h1 class="text-gray-950">404</h1>
            <!-- <div class="error-animation">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
            </div> -->
        </div>

        <!-- Error Message -->
        <div class="error-message">
            <h2>Oops! Page Not Found</h2>
            <p>The page you are looking for might have been removed, renamed, or is temporarily unavailable.</p>
        </div>

        <!-- Action Buttons -->
        <div class="error-actions">
            <button routerLink="/" class="btn bg-gray-950 text-white hover:bg-gray-800 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <polyline points="9,22 9,12 15,12 15,22" />
                </svg>
                Go to Homepage
            </button>

            <button (click)="goBack()" class="btn btn-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <polyline points="15,18 9,12 15,6" />
                </svg>
                Go Back
            </button>
        </div>

        <!-- Helpful Links -->
        <div class="helpful-links">
            <p>Maybe try one of these pages instead:</p>
            <ul>
                <li><a routerLink="/sign-up">Customer Signup</a></li>
                <li><a routerLink="/onboarding">Business Signup</a></li>
                <li><a routerLink="/">Contact Support</a></li>
            </ul>
        </div>
    </div>
</div>